



























import Vue from "vue";
import Component from "vue-class-component";
import DadosVeiculo from "@/components/dados/DadosVeiculo.vue";
import DetalhesPlano from "@/components/detalhes/DetalhesPlano.vue";
import DetalhesProsseguir from "@/components/detalhes/DetalhesProsseguir.vue";
import DetalhesTerceiros from '@/components/detalhes/DetalhesTerceiros.vue';
import DetalhesAssistencia from '@/components/detalhes/DetalhesAssistencia.vue';
import DetalhesGuincho from '@/components/detalhes/DetalhesGuincho.vue';
import DetalhesAgregado from '@/components/detalhes/DetalhesAgregado.vue';
import { detalhesCobertura } from '@/components/detalhes/detalhes';

@Component({
    components: {
        DadosVeiculo,
        DetalhesTerceiros,
        DetalhesGuincho,
        DetalhesAgregado,
        DetalhesAssistencia,
        DetalhesProsseguir,
        DetalhesPlano
    }
})
export default class Detalhes extends Vue {

    get detalhesCobertura () {
        return detalhesCobertura;
    }

    public mounted () {
        this.$store.commit("SET_SIDEBAR_SHOWING", true);
        this.$store.commit('SET_SIDEBAR_ENABLED', true);
    }

    public visibilityChanged (isVisible: boolean) {
        this.$store.commit("SET_SIDEBAR_SHOWING", !(this.$vuetify.breakpoint.xsOnly && isVisible));
    }

    get fipeValor () {
        return this.$store.state.cotacao.valor_fipe;
    }
}
